import 'css-chunksrc/client/scenes/resourceEdition/styles.scss';export default {
  "resourceEdition": "_resourceEdition_mv20o_1",
  "header": "_header_mv20o_7",
  "body": "_body_mv20o_13",
  "col": "_col_mv20o_22",
  "footer": "_footer_mv20o_31",
  "button": "_button_mv20o_39",
  "title": "_title_mv20o_44",
  "tags": "_tags_mv20o_48",
  "iconBox": "_iconBox_mv20o_57",
  "icon": "_icon_mv20o_57",
  "tagFormWrapper": "_tagFormWrapper_mv20o_69",
  "tagInput": "_tagInput_mv20o_77",
  "tagForm": "_tagForm_mv20o_69",
  "affiliation": "_affiliation_mv20o_87",
  "addButton": "_addButton_mv20o_99",
  "secondaryCriteria": "_secondaryCriteria_mv20o_115",
  "secondaryCriteriaHeader": "_secondaryCriteriaHeader_mv20o_120",
  "label": "_label_mv20o_127",
  "configurationIconBox": "_configurationIconBox_mv20o_133",
  "configurationIcon": "_configurationIcon_mv20o_133",
  "contextualMenuIcon": "_contextualMenuIcon_mv20o_150"
};